import React from 'react'
import styled from 'styled-components'
import {AkErrorIcon, AkEditorCloseIcon, AkChevronDownIcon} from '@fuegokit/fuegoicons-react'
import {Box, Stack, Text, VisuallyHidden, themeGet, ToggleButton, Link, Button} from '../../..'

// check icon
export const TestVisualOne = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="3" fill="#579DFF" />
      <rect x="4" y="6" width="16" height="12" rx="1" stroke="white" strokeWidth="2" />
      <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
// error icon
export const TestVisualTwo = () => {
  return (
    <Box sx={{color: 'icon.danger'}}>
      <AkErrorIcon />
    </Box>
  )
}
// rocket icon
export const TestVisualThree = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="3" fill="#9F8FEF" />
      <path
        d="M19.1048 5.10089C16.3895 4.98775 13.3207 4.69077 10.4215 7.5899C8.78307 9.14356 7.51442 11.0453 6.70921 13.1548L11.0862 17.5318C13.1957 16.7266 15.0975 15.458 16.6511 13.8195C19.5503 10.9204 19.225 7.82324 19.1401 5.13624"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99609 16.4424L8.61016 18.5778"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.76465 14.208L5.62212 15.5869"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3871 7.55413C6.05258 5.42574 4.29188 9.94416 4.29188 9.94416L7.1486 11.9523"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6501 13.8191C18.7785 18.1536 14.253 19.9073 14.253 19.9073L12.2519 17.0576"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.707 7.18652L17.0204 11.4999"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
// user icon
export const TestVisualFour = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="3" fill="#E2B203" />
      <circle cx="12" cy="8" r="3" stroke="white" strokeWidth="2" />
      <path d="M20 20C20 16 16 14 12 14C8 14 4 16 4 20" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
// large icon for rule item right
export const TestVisualFive = () => {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="32" height="32" rx="3" fill="#579DFF" />
      <rect x="8.5" y="10" width="16" height="12" rx="1" stroke="white" strokeWidth="2" />
      <path d="M13.5 16L15.5 18L19.5 14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
// post function icon
export const TestVisualSix = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="3" fill="#9F8FEF" />
      <path
        d="M8 12H12M12 12V7H20M12 12V17H20M9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export type TestCopyProps = {
  title?: string
  description?: string
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TestCopy = ({
  title = 'Rule title',
  description = 'Description of the rule'
}: TestCopyProps): JSX.Element => {
  return (
    <Box sx={{display: 'flex', alignItems: 'baseline', gap: 2}}>
      <Text as="p" sx={{fontWeight: 'bold'}}>
        {title}
      </Text>
      <Text as="p">{description}</Text>
    </Box>
  )
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ConditionCopy = ({title = 'Issue', description = 'Created'}: any): JSX.Element => {
  return (
    <Box sx={{display: 'flex', alignItems: 'baseline', gap: 2}}>
      <Text as="p" sx={{fontWeight: 'bold'}}>
        {title}
      </Text>
      <Text as="p">{description}</Text>
    </Box>
  )
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ProjectCopy = ({title = 'Project: Consumer Lending (CL)'}: any): JSX.Element => {
  return (
    <Box sx={{display: 'flex', alignItems: 'baseline', gap: 2}}>
      <Text as="p" sx={{fontWeight: 'bold'}}>
        {title}
      </Text>
    </Box>
  )
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IssueTypesCopy = ({title = 'Issue Types'}: any): JSX.Element => {
  return (
    <Box sx={{display: 'flex', alignItems: 'baseline', gap: 2}}>
      <Text as="p" sx={{fontWeight: 'bold'}}>
        {title}
      </Text>
    </Box>
  )
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PostFunctionCopy = ({object = 'Role member', action = 'Assign to'}: any): JSX.Element => {
  return (
    <Box sx={{display: 'flex', alignItems: 'baseline', gap: 2}}>
      <Text as="p">{action}</Text>
      <Text as="p" sx={{fontWeight: 'bold'}}>
        {object}
      </Text>
    </Box>
  )
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SelectPostFunctionCopy = ({object = 'Post-function', action = 'Select'}: any): JSX.Element => {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
      <Text as="p">{action}</Text>
      <Text as="p" sx={{fontWeight: 'bold'}}>
        {object}
      </Text>
    </Box>
  )
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RuleItemRight = ({title = 'What', description = 'Description of what'}: any): JSX.Element => {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column'}}>
      <Text as="p" sx={{fontWeight: 'bold'}}>
        {title}
      </Text>
      <Text as="p">{description}</Text>
    </Box>
  )
}
export const dummyTextBlocks = [
  {title: 'Project', description: 'Same as current issue'},
  {title: 'Issue type', description: '[System] Incident'},
  {title: 'Copy fields to new issue mode', description: 'Only copy or set'}
]
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RuleItemRightExpandedCopy = ({textBlocks}: any): JSX.Element => {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
      {/*eslint-disable-next-line @typescript-eslint/no-explicit-any*/}
      {textBlocks.map((textBlock: any, index: any) => {
        return (
          <Box key={index + '12345'} sx={{display: 'flex', alignItems: 'baseline'}}>
            <Stack size={1} direction={`row`}>
              <Text sx={{fontWeight: 'bold'}}>{textBlock.title}:</Text>
              <Text>{textBlock.description}</Text>
            </Stack>
          </Box>
        )
      })}
      <Link href={'https://google.com'}>Link</Link>
    </Box>
  )
}
// fake toggle button
export const TestToggle = ({...props}) => {
  const {toggle, onOpenChange} = props
  return (
    <ToggleButton onClick={toggle} {...props}>
      <VisuallyHidden>Open</VisuallyHidden>
      <AkChevronDownIcon />
    </ToggleButton>
  )
}
// fake dismiss button
export const TestDismiss = ({...props}) => {
  return (
    <StyledDismissButton onClick={() => alert('dismiss')} {...props}>
      <VisuallyHidden>Open</VisuallyHidden>
      <AkEditorCloseIcon />
    </StyledDismissButton>
  )
}
const StyledDismissButton = styled(Button)`
  // reset
  appearance: none;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  user-select: none;
  display: flex;
  align-items: center;
  color: inherit;
  font-weight: normal;
  //
  font-size: ${themeGet('fontSizes.2')};
  text-decoration: none;
  opacity: 0.85;
  font-weight: ${themeGet('fontWeights.semibold')};
  padding: 2px 4px;
  border-radius: ${themeGet('radii.1')};
  &:hover,
  &:focus {
    opacity: 1;
    text-decoration: none;
    color: ${themeGet('colors.link.default')};
    background-color: ${themeGet('colors.background.neutral.subtle.hovered')};
  }
  &:active {
    opacity: 1;
    text-decoration: none;
    background-color: ${themeGet('colors.background.selected.default.[default]')};
    color: ${themeGet('colors.text.selected')};
  }
  &:focus,
  .focus-visible {
    outline: none;
    transition-duration: 0s, 0.2s;
    box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
  }
  &:focus:not(:focus-visible):not(.focus-visible) {
    box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
  }
  svg {
    transition: transform 0.15s ease;
  }
`
